// src/ui/shell/Footer.tsx (T1): the page footer: the builder's logo (44px, left), the facts ("Custom homes in
// {region}" beside the logo, as in Direction D, or the name when no region label is set; hub, since; phone as a
// tel: link; the builder's site, with the board hint for a confirmed member, ONSITE 6), and "Powered by homebuild",
// the only place it appears, at 11px. Separators are drawn
// between items so a wrap never leaves a stray "·"; stacked on phone. Root class: hb-foot.
import type { ComponentChildren } from "preact";
import { joinParts } from "../../../shared/format";
import { tenant } from "../../state/session";
import { siteHost, siteHref } from "../../lib/site-link";
import { Logo } from "../Logo";

export function Footer(props: { extra?: ComponentChildren; /** The link back to the builder's site (the auth pages have it in their top bar). */ siteLink?: boolean }) {
  const t = tenant.value;
  if (!t) return null;
  // Only what the builder gave: the hub, and "Since" only with a real founding year. Never an empty piece.
  const where = joinParts([t.region.hub, t.since ? `Since ${t.since}` : null]);
  return (
    <footer class="hb-foot foot">
      <div class="wrap">
        <Logo class="foot-logo" />
        <p class="facts">
          <span>{t.region.label ? `Custom homes in ${t.region.label}` : t.name}</span>
          {where ? <span>{where}</span> : null}
          {t.contact.phone?.trim() ? <a href={t.contact.phoneHref}>{t.contact.phone}</a> : null}
          {props.siteLink === false ? null : <a href={siteHref(t)}>{siteHost(t.contact.site)}</a>}
          {t.legal?.privacyUrl ? (
            <a class="foot-privacy" href={t.legal.privacyUrl}>
              Privacy
            </a>
          ) : null}
        </p>
        {props.extra}
        <p class="powered">Powered by homebuild</p>
      </div>
    </footer>
  );
}
